(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unsupervised-home"] && !Shopify.designMode) return;
  try {
    
(async () => {
const { Component } = await import('@theme/component');
class UnCampaign extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.setupCampaign();
  }
  updatedCallback() {
    super.updatedCallback();
    this.setupCampaign();
  }
  setupCampaign() {
    this.releaseCampaign();
    this.campaignAbort = new AbortController();
    const signal = this.campaignAbort.signal;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const enableMotion = () => {
      this.campaignObserver?.disconnect();
      this.classList.remove('uc-motion');
      if (motion.matches || !('IntersectionObserver' in window)) return;
      this.campaignObserver = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-visible');
          this.campaignObserver.unobserve(entry.target);
        }
      }, { threshold: 0.08 });
      for (const el of this.querySelectorAll('.uc-reveal')) this.campaignObserver.observe(el);
      this.classList.add('uc-motion');
    };
    enableMotion();
    motion.addEventListener('change', enableMotion, { signal });
    const deal = this.querySelector('.uc-deal');
    const deck = this.querySelector('.uc-deck');
    const status = this.querySelector('[data-deal-prefix]');
    if (deal && deck && deck.children.length > 1) {
      deal.hidden = false;
      deal.addEventListener('click', () => {
        deck.classList.remove('is-dealt');
        deck.append(deck.firstElementChild);
        for (const card of deck.children) card.classList.add('is-visible');
        if (status) status.textContent = `${status.dataset.dealPrefix} ${deck.firstElementChild.dataset.edition}.`;
        this.campaignFrame = requestAnimationFrame(() => deck.classList.add('is-dealt'));
      }, { signal });
    }
    const hero = this.querySelector('.uc-hero');
    if (hero && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      hero.addEventListener('pointermove', event => {
        if (motion.matches) return;
        const rect = hero.getBoundingClientRect();
        cancelAnimationFrame(this.parallaxFrame);
        this.parallaxFrame = requestAnimationFrame(() => {
          hero.style.setProperty('--uc-x', `${((event.clientX - rect.left) / rect.width - 0.5) * 10}px`);
          hero.style.setProperty('--uc-y', `${((event.clientY - rect.top) / rect.height - 0.5) * 8}px`);
        });
      }, { signal, passive: true });
      hero.addEventListener('pointerleave', () => {
        cancelAnimationFrame(this.parallaxFrame);
        hero.style.setProperty('--uc-x', '0px');
        hero.style.setProperty('--uc-y', '0px');
      }, { signal });
    }
  }
  releaseCampaign() {
    this.campaignAbort?.abort();
    this.campaignObserver?.disconnect();
    cancelAnimationFrame(this.campaignFrame);
    cancelAnimationFrame(this.parallaxFrame);
  }
  disconnectedCallback() {
    this.releaseCampaign();
    super.disconnectedCallback();
  }
}
if (!customElements.get('un-campaign')) customElements.define('un-campaign', UnCampaign);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unsupervised-navigation"]) return;
  try {
    
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.un-mobile-nav[open]');
  if (menu) { menu.open = false; menu.querySelector('summary')?.focus(); }
});
document.addEventListener('click', (event) => {
  const menu = document.querySelector('.un-mobile-nav[open]');
  if (menu && !menu.contains(event.target)) menu.open = false;
});
(async () => {
const { StandardEvents } = await import('@shopify/events');
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const refreshCount = async () => {
    const link = document.querySelector('.un-cart');
    if (!link) return;
    try {
      const response = await fetch(link.getAttribute('href') + '.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      link.textContent = link.textContent.replace(/\(\d+\)/, '(' + cart.item_count + ')');
    } catch {}
  };
  if (event.promise) event.promise.then(refreshCount).catch(() => {});
  else refreshCount();
});
})();

  } catch(e) { console.error(e); }
})();
})();
